import { OperationShort } from 'model/modules/operations/operationShort';
import mapCurrencyFromApi from 'rtkQuery/sharespro/mapper/shared/mapCurrencyFromApi';

const mapOperationShortFromApi = (api: ApiOperationShort): OperationShort => {
  return {
    currency: mapCurrencyFromApi(api.currency),
    date: new Date(api.date * 1000),
    amount: api.amount,
    quantity: api.quantity,
    type: api.type,
  };
};

export default mapOperationShortFromApi;
